<template lang="pug">
.rewards-item
  .rewards-item__image
    img(:src="rewardImageSrc")
  .rewards-item__name {{ rewardName }}
</template>

<script>

export default {
  name: "RewardsItem",
  props: {
    rewardId: {
      type: String,
      default: "",
    },
  },
  computed: {
    rewardImageSrc() {
      return require(`@/assets/images/rewards/items/${this.rewardId}.png`);
    },
    rewardName() {
      return this.$t(`promo.rewards.names.${this.rewardId}`)
    },
  },
};
</script>
